function identifier(tc_id = {}, pb_id = {}) {
  return pb_id.name && tc_id.name === pb_id.name;
}

export default identifier;